<template>
    <div class="consultar-Pedidos">
      <g-card
        class="card-consultas-pedidos-cliente"
        margem="20px"
        :expansivel="true"
        :comecaFechado="false"
      >
        <template #cabecalho>
          <div class="header-filtros">
            <div class="titulo-filtros-cabecalho">Andamento de Pedidos</div>
            <div class="header-icons">
              <g-button
                class="trash-box"
                tipo="cinza"
                altura="35px"
                largura="45px"
                icone="icone_lixo.svg"
                tamanhoIcone="15px"
                somenteIcone
                :sombreado="false"
                v-tooltip="'Limpar filtro'"
                @click="limparFiltro"
              />
              <g-button
                class="buscar-button-header-filtro"
                largura="150px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="Grid()"
              >
                BUSCAR
              </g-button>
            </div>
          </div>
        </template>
        <g-form>
          <div class="consultar-pedido-conteudo espacamento-filtros">
            <div class="unidade">
              <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
              <PDropDown
              class="unidade-input input-label unidade"
              placeholder="TODAS"
              :filter="true"
              :options="UnidadeArray"
              optionLabel="nome"
              optionValue="id"
              v-model="objFiltros.UnidadeId"
              >
              </PDropDown>
            </div>

            <div class="representante">
              <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
              <cliente-dropdown
                class="cliente-input input-label"
                v-model="objFiltros.ClienteId" 
                @change="ativaClienteAgrupador"
                :representanteId="this.$store.state.representanteSelecionadoId" 
                :empresaId="objFiltros.UnidadeId"
                />
            </div>

            <div class="cliente">
              <div class="numero-solicitacao-titulo titulo-conteudo-filtros">
                Número da Solicitação
              </div>
              <PInputText
                class="numero-solicitacao-input input-label"
                placeholder="Insira o nº da Solicitação"
                v-model="objFiltros.NumeroSolicitacao"
              />
            </div>

            <div class="numero-solicitacao">
              <div class="numero-pedido-titulo titulo-conteudo-filtros">Número do Pedido</div>
              <PInputText
                class="numero-pedido-input input-label"
                placeholder="Insira o nº do pedido"
                v-model="objFiltros.NumeroPedido"
              />
            </div>

            <div class="nome-produto">
              <div class="data-entrega-titulo titulo-conteudo-filtros">Data de Entrega</div>
              <div class="input-data">
                <div class="data-inicio">
                  <g-date-input
                    class="data-entrega-inicio-input input-label"
                    placeholderinput="Início"
                    alturainput="40px"
                    largurainput="100%"
                    tamanhobotao="35px"
                    invertido
                    v-model="objFiltros.DataEntregaInicio"
                    :dataPassadas="true"
                  ></g-date-input>
                </div>
                <div class="data-periodo"> à </div>
                <div class="data-termino">
                  <g-date-input
                    class="data-entrega-termino-input input-label"
                    placeholderinput="Término"
                    alturainput="40px"
                    largurainput="100%"
                    tamanhobotao="35px"
                    invertido
                    v-model="objFiltros.DataEntregaTermino"
                    :dataPassadas="true"
                  ></g-date-input>
                </div>
              </div>
            </div>

            <div class="numero-pedido">
              <div class="tipo-pedido-titulo titulo-conteudo-filtros">Tipo do Pedido</div>
              <PDropDown
                class="tipo-pedido-input input-label"
                placeholder="Selecione"
                v-model="objFiltros.TipoPedido"
                :options="TipoPedidoArray"
                optionLabel="text"
                optionValue="value"
              />
            </div>

            <div class="tipo-pedido">
              <div class="codigo-produto-titulo titulo-conteudo-filtros"> Produto </div>
              <PDropDown
              class="nome-produto-input input-label"
              v-model="objFiltros.NomeProduto"
              placeholder="Insira o nome do produto"
              optionLabel="labelProduto"
              optionValue="produtoId"
              @filter="getProduto($event.value)"
              :filter="true"
              :options="ProdutoArray"
              />
            </div>

            <div class="data-entrega">
              <div class="status-pedido-titulo titulo-conteudo-filtros">Status do Pedido</div>
              <PDropDown
                class="status-pedido-input input-label unidade"
                placeholder="TODOS"
                v-model="objFiltros.Status"
                :options="StatusArray"
                optionLabel="text"
                optionValue="value"
              />
            </div>

            <div class="status-pedido">
              <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
              <div class="parametros-checkboxes">
                <div class="consultar-dados checkbox">
                  <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados" class="checkbox-consultas" v-model="objFiltros.DadosClienteAgrupador"></PCheckBox>
                  <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                </div>
                <!-- <div class="componentes-expandidos checkbox">
                  <PCheckBox id="componentes-expandidos" class="checkbox-componentes" v-model="objFiltros.ComponentesExpandidos"></PCheckBox>
                  <label class="componentesExpandidos label-checkbox" for="componentes-expandidos"> Trazer os componentes expandidos? </label>
                </div> -->
              </div>
            </div>

            <!-- <div class="status-pedido">
              <div class="status-pedido-titulo titulo-conteudo-filtros">Status do Pedido Parcela</div>
              <PDropDown
                class="status-pedido-input input-label"
                placeholder="Selecione"
                v-model="objFiltros.StatusPedidoParcela"
                :options="StatusParcelaArray"
                optionLabel="text"
                optionValue="value"
              />
            </div> -->

            <div class="parametros">

            </div>
        </div>
        </g-form>
        <div class="buscar-button-filtro">
          <g-button
            class="buscar-button"
            largura="300px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="Grid()"
          >
            BUSCAR
          </g-button>
        </div>

      </g-card>
       <g-card
        paddingDefault="0 0em 1em"
        margem="20px"
        :expansivel="false"
        :temCabecalho="false"
        class="card-resultado"
      >
        <div v-if="pt1" class="card-resultado-content">
          <img
            class="imagem-nenhuma-info"
            src="@/assets/imgs/Ilustracao_erro.svg"
          />
          <div class="card-resultado-text-small">
            Verifique os filtros e clique em buscar para exibir os resultados
          </div>
        </div>
        <div v-else-if="!pt1">
          <g-data-table
          TextoVazio="Nenhum pedido encontrado"
          Titulo="Pedidos"
          :colunas="Colunas"
          :Filtros="Filtro"
          :Paginacao="true"
          :numeroBotoesAcao="1"
          :valores="PedidosArray"
          :NumeroLinhas="100"
          :FiltrosEspecificos = "true"
          :Imprimivel= "true"
          :NotaFiscal="true"
          v-on:OnNotaFiscal="etiquetaRota"
          TextNotaFiscal="Imprimir a Etiqueta"
          :rowEditor="true"
          altura="auto"
          :campoAgrupador="'empresaCliente'"
          :campoExibicaoGrupo="'empresaCliente'"
          v-on:duploClickLinha="detalhesPedido"
          dataKey="pedidoParcela"
          v-on:clickImprimir="abrirPDF"
          TextImprimir="Gerar PDF"
          ExportarPdf
          :Calendario= "true"
          :ButtonStatus="true"
        >
        <!-- <template #expansivel="slotProps">
            <g-data-table
              TextoVazio="Nenhum Componente Encontrado"
              Titulo="Componente"
              altura="auto"
              :valores="slotProps.linha.data.componentePedidoAprovacaoArray"
              :colunas="ColunasSubGridComponente"
              :NumeroLinhas="2"
              :Editavel= "false"
              :Imprimivel= "false"
              :rowEditor="false"
              :checkprancheta = "false"
              :esconderColunaFrozen = "true"
              :esconderHeader = "true"
              :FiltrosEspecificos = "false"
              :FiltroGeral = "false"
              :Paginacao="false"
              dataKey="PedidoParcelaComponenteId"
            >
            </g-data-table>
          </template> -->
        </g-data-table> 
        </div>
      </g-card>
    </div>

    <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
      <div class="render" v-if="renderiza">
        <PedidoEmAndamentoPDF 
          :PropstyleImg= "this.styleImg" 
          :PropcaminhoImagem="this.caminhoImagem" 
          :tituloDetalhes="false" 
          v-on:termino="gerarPdf" 
          :pedidoSelecionado="pedidoId" 
        />
      </div>
    </g-pdf>
  </template>

<script>
import PedidoAguardandoAprovacao from './PedidoAguardandoAprovacao.js'
export default PedidoAguardandoAprovacao
</script>

  <style scoped>
  .consultar-pedido-conteudo {
    margin: 20px 0;
  }
  .data-entrega-data,

.checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}

.label-checkbox {
  color: #8A8A8A;
  text-align: left;
  font-size: 15px;
  font-family: 'MontSerrat';
  margin-left: 5px;
}

  .input-label {
    margin-bottom: 15px;
  }
  .card-resultado-text-small {
    color: #4f4c4d;
    font-family: "MontSerrat";
  }
  .card-resultado-content {
    display: flex;
    flex-direction: column;
  }
  .imagem-nenhuma-info {
    margin: 60px auto 20px auto;
    max-height: 500px;
  }

  .codigo-nome-produto {
    width: 100%;
    display: grid;
    grid-template-columns: 30% auto;
    grid-template-rows: auto;
    grid-column-gap: 20px;
    align-items: flex-end;
    align-self: flex-start;
    }

  :deep(.p-inputtext){
    width: 100%;
  }

  @media (min-width: 310px) {
    .consultar-pedido-conteudo {
      display: flex;
      flex-direction: column;
    }
    .input-label {
      width: 100%;
    }
    .buscar-button-filtro {
      display: flex;
      justify-content: center;
      align-items: self-end;
    }
    .imagem-nenhuma-info {
      height: 15vh;
    }
  }

  @media (min-width: 368px) {
  }

  @media (min-width: 600px) {
    .consultar-pedido-conteudo {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(5, auto);
      grid-column-gap: 20px;
    }

    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .representante { grid-area: 1 / 2 / 2 / 3; }
    .cliente { grid-area: 2 / 1 / 3 / 2; }
    .numero-solicitacao { grid-area: 2 / 2 / 3 / 3; }
    .numero-pedido { grid-area: 3 / 1 / 4 / 2; }
    .tipo-pedido { grid-area: 3 / 2 / 4 / 3; }
    .codigo-nome-produto { grid-area: 4 / 1 / 5 / 2; }
    .data-entrega { grid-area: 4 / 2 / 5 / 3; }

    .buscar-button-filtro {
      display: none;
    }
    .imagem-nenhuma-info {
      height: 25vh;
    }
  }

  @media (min-width: 801px) {
  .consultar-pedido-conteudo {
    margin: 20px 20px 0 20px;
  }

  .parametros-checkboxes {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
  }
  }

  @media (min-width: 1025px) {

  .consultar-pedido-conteudo {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, auto);
  }

  .cliente { grid-area: 1 / 3 / 2 / 4; }
  .numero-solicitacao { grid-area: 2 / 1 / 3 / 2; }
  .numero-pedido { grid-area: 2 / 2 / 3 / 3; }
  .tipo-pedido { grid-area: 2 / 3 / 3 / 4; }
  .codigo-nome-produto { grid-area: 3 / 1 / 4 / 2; }
  .data-entrega { grid-area: 3 / 2 / 4 / 3; }

  .card-resultado-text-small {
    font-size: 16px;
  }

  .imagem-nenhuma-info {
    height: 35vh;
  }
  }

  @media (min-width: 1281px) {
  }

  @media (min-width: 1500px) {
    .consultar-pedido-conteudo {
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, auto);
    }

    .numero-solicitacao { grid-area: 1 / 4 / 2 / 5; }
    .numero-pedido { grid-area: 2 / 1 / 3 / 2; }
    .tipo-pedido { grid-area: 2 / 2 / 3 / 3; }
    .codigo-nome-produto { grid-area: 2 / 3 / 3 / 4; }
    .data-entrega { grid-area: 2 / 4 / 3 / 5; }
  }
  </style>